<div class="all-title-box"><div class="container text-center"><h1>Customer Login</h1></div></div>
<div class="section wb auth-page">
  <div class="container">
    <form [formGroup]="form" (ngSubmit)="submit()" class="auth-card">
      <h3>Sign in</h3>
      <input class="form-control" type="email" formControlName="email" placeholder="Email">
      <input class="form-control" type="password" formControlName="password" placeholder="Password">
      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
      <button class="btn btn-light btn-radius btn-brd grd1 btn-block" type="submit" [disabled]="isSubmitting">{{ isSubmitting ? 'Signing in...' : 'Sign in' }}</button>
      <div class="auth-links-row">
        <a routerLink="/forgot-password">Forgot password?</a>
        <a routerLink="/register">Create account</a>
      </div>
    </form>
  </div>
</div>
